import React, { useState, lazy, Suspense } from "react";
import { Grid, CardActionArea, Dialog } from "@mui/material";
import Check from "../../../auth/ability";
import { CAN, SUBJECTS } from "../../../auth/permissions";
import { grey } from "@mui/material/colors";
import DottedTile from "../../common/DottedTile";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { CreateVehicleModelSkeleton } from "../../common/DialogSkeleton";

const CreateVehicleModel = lazy(() => import("./CreateVehicleModel.jsx"));

const CreateVehicleModelTile = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);

  return (
    <>
      <Check I={CAN.CREATE} a={SUBJECTS.VEHICLE_MODEL}>
        <Grid item xs={6} sm={4} md={2}>
          <CardActionArea onClick={handleOpen}>
            <DottedTile title={"CREATE A MODEL"}>
              <DirectionsCarIcon sx={{ fontSize: "3.5rem", color: grey[500] }} />
            </DottedTile>
          </CardActionArea>
        </Grid>
      </Check>

      {openModal && (
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              width: "90%",
              maxWidth: "700px",
              maxHeight: "80vh",
              overflowY: "auto",
            },
          }}
        >
          <Suspense fallback={<CreateVehicleModelSkeleton />}>
            <CreateVehicleModel
              open={openModal}
              toggleDialog={() => setOpenModal(false)}
            />
          </Suspense>
        </Dialog>
      )}
    </>
  );
};

export default CreateVehicleModelTile;